// HorizontalBarChart.js
import React, { useEffect, useRef } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  BarController,
} from "chart.js";

// Register the necessary components
ChartJS.register(CategoryScale, LinearScale, BarElement, BarController);

const HorizontalBarChart = () => {

  const data = {
    labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
    datasets: [
      {
        label: "# of Votes",
        data: [12, 19, 3, 5, 2, 3],
        backgroundColor: "#4A3AFF",
        borderRadius: 10, // border radius for all bars
      },
    ],
  };

  const options = {
    indexAxis: "y", // use 'y' for horizontal bars
    plugins: {
      legend: {
        display: false, // hide the legend or customize as needed
      },
    },
    scales: {
      y: {
        grid: {
          display: false, // hide y-axis grid lines
        },
      },
    },
  };

  return <Bar data={data} options={options} />;
};

export default HorizontalBarChart;
